/** @format */
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import { Trans, useTranslation } from 'next-i18next';
import React, { useMemo, useState } from 'react';

import { SearchFacet } from '@toucan/common/services/search/constants';

import { useSearchParams } from '@toucan/client/features/search/components/model-search-results/hooks/use-search-params';
import {
    Filter,
    SearchResultsType,
} from '@toucan/client/features/search/components/model-search-results/types';

import { SearchFilterGroup } from './components/search-filter-group';
import { StyledModalFilters } from './filters-modal.styles';

export function ModalFilters({
    testId,
    filters,
    searchResults,
    handleFilterOpen,
    isLoadingFilters,
}: {
    testId: string;
    isLoadingFilters: boolean;
    filters: Filter[];
    searchResults: SearchResultsType;
    handleFilterOpen: (id: SearchFacet) => Promise<void>;
}) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const { selectedFilters } = useSearchParams();

    function getFiltersAppliedCount() {
        return Object.values(selectedFilters).flat().length;
    }

    const loadingFilters = useMemo(
        () => (
            <div className="small-tablet-filters">
                <div className="control-group-item">
                    <Trans components={{ 'bold-text': <strong /> }}>
                        {t('<bold-text>Filters:</bold-text>')}
                    </Trans>
                    <Skeleton
                        data-testid="search-results-modal-filters__count-skeleton"
                        className="filters-count-skeleton"
                        variant={SkeletonVariant.BLOCK}
                    />
                </div>
            </div>
        ),
        []
    );

    return (
        <StyledModalFilters>
            {isLoadingFilters ? (
                loadingFilters
            ) : (
                <div
                    className="small-tablet-filters control-group"
                    data-testid={`${testId}__filters`}
                >
                    <button
                        data-testid={`${testId}__filters-button`}
                        className="modal-filter-button control-group-item"
                        onClick={() => {
                            setIsOpen(true);
                        }}
                    >
                        <Trans components={{ 'bold-text': <strong /> }}>
                            {t(
                                '<bold-text>Filters:</bold-text> {{count}} applied',
                                {
                                    count: getFiltersAppliedCount(),
                                }
                            )}
                        </Trans>
                    </button>
                    <SearchFilterGroup
                        isLoadingFilters={isLoadingFilters}
                        isOpen={isOpen}
                        resultsCount={searchResults.totalResults}
                        filters={filters}
                        onFilterOpen={handleFilterOpen}
                        onMenuClose={() => setIsOpen(false)}
                        data-testid={`${testId}__filters-group`}
                    />
                </div>
            )}
        </StyledModalFilters>
    );
}
